// components/hauler/HaulerToast.js
// Lightweight transient banner for lifecycle action feedback.
// Self-contained — does not couple to the resident-side useToast.

import React, { useEffect } from "react";

const COLORS = {
  ok: { bg: "#03A66A", text: "#0A1628" },
  warn: { bg: "#F29727", text: "#0A1628" },
  err: { bg: "#D95252", text: "#F2F2F2" },
};

export default function HaulerToast({ message, kind = "ok", onDismiss, durationMs = 3200 }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => onDismiss && onDismiss(), durationMs);
    return () => clearTimeout(t);
  }, [message, durationMs, onDismiss]);

  if (!message) return null;
  const p = COLORS[kind] || COLORS.ok;

  return (
    <div style={{
      position: "fixed",
      left: "50%",
      bottom: 96,
      transform: "translateX(-50%)",
      zIndex: 80,
      background: p.bg,
      color: p.text,
      padding: "10px 16px",
      borderRadius: 999,
      fontSize: 13,
      fontWeight: 700,
      maxWidth: "min(420px, calc(100% - 32px))",
      textAlign: "center",
      boxShadow: "0 8px 24px rgba(0,0,0,.35)",
    }}>
      {message}
    </div>
  );
}
